var render = function render(){var _vm=this,_c=_vm._self._c;return _c('logo-image',{staticClass:"h-full",attrs:{"src":_vm.fetchLogo}})
}
var staticRenderFns = []

export { render, staticRenderFns }